// extracted by mini-css-extract-plugin
export default {"placeholder":"ViewportLazyMount_placeholder__5lUNE","viewportLazyShimmer":"ViewportLazyMount_viewportLazyShimmer__xV5Ti"};